import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import authServices from "../../../../services/authServices";
import { getNSWToken, getSearchResults } from "./data-service";
import ResultCard from "./result-card";
import qs from "qs" ;
import { DASHBOARD_ROUTE } from "../../../../routes";
import { SEARCH_QUERY_TOOL_DETAILS_ROUTE } from "../../dashboard-routes";

const SearchQueryToolResultPage = () => {
    const location = useLocation();
    const history = useHistory();
    const [results, setResults] = useState([]);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [filteredResults, setFilteredResults] = useState([]);
    const [filters, setFilters] = useState({
        category : "",
        status : "",
        postcode : "",
    });

    useEffect(() => {
        let query = new URLSearchParams(location.search);
        search(query.get("search"));
    }, []);

    function handleSubmit(e) {
        // set filters
        e.preventDefault();

        // let filterdRes = results.filter(r => {
        //     if(r.postcode === filters.postcode) return true ;
        //     if(r.category === filters.category) return true ;
        //     if(r.status.toLowerCase() === filters.status) return true ;

        //     return false;
        // })

        //console.log("filters",filters);

        let filterdRes = results.filter(r => {
            
            if(filters.postcode !== "" && r.postcode !== filters.postcode) 
                return false ;
            if(filters.category !== "" && r.category !== filters.category) 
                return false ;
            if(filters.status !== "" && r.status.toLowerCase() !== filters.status) 
                return false ;

            return true;
        })

        //console.log("FR",filterdRes);
        setFilteredResults(filterdRes);
    }

    function showDetails(id) {
        var data = qs.stringify({
            licenseID: id,
        });

        history.push({
            pathname: DASHBOARD_ROUTE + SEARCH_QUERY_TOOL_DETAILS_ROUTE,
            search: data,
        });
    }

    async function search(queryString) {
        setIsLoading(true);

        // let tokenValid = false;
        let [nswToken,nswTokenError] = await authServices.getNSWAccessToken();

        // if (nswToken) {
        //     tokenValid = true;
        // }

        // if (!tokenValid) {
        //     const [res, nswTokenError] = await getNSWToken();
        //     if (nswTokenError) {
        //         setError(nswTokenError);
        //         setIsLoading(false);
        //         // console.error(nswTokenError);
        //         return;
        //     } else {
        //         nswToken = res.access_token;
        //         authServices.setNSWAccessToken(nswToken);
        //     }
        // }

        if(nswTokenError) {
            setError(nswTokenError);
            setIsLoading(false);
            return false;
        }

        const [result, resultError] = await getSearchResults(queryString, nswToken);
        setIsLoading(false);

        if (resultError) {
            setError(resultError);
            return;
        }

        if (result) {
            setResults(result);
            setFilteredResults(result);
        }

        return false;
    }
    const minInputWidth = "10rem";

    return (
        <div className="container-fluid p-0 w-100">
            <div className="card p-4 m-0 no-radius border-0 border-bottom">
                <h5 className="card-title">Search Query Tool</h5>
                <form onSubmit={handleSubmit}>
                    <div className="container-fluid">
                        <div className="d-xl-flex">
                            <div className="me-3 my-3">
                                <b className="text-nowrap">Refine Search</b>
                            </div>
                            <div className="flex-fill">
                                <div className="row row-cols-md-2">
                                    <div className="col-md p-0">
                                        <div className="m-2 d-md-flex align-items-center">
                                            <label
                                                htmlFor="category"
                                                className="me-3 mb-2 mb-md-0 flex-fill text-md-end"
                                                style={{
                                                    width: "20ch",
                                                }}
                                            >
                                                Category:
                                            </label>
                                            <select
                                                className="form-select flex-fill"
                                                name="category"
                                                id="category"
                                                value={filters.category}
                                                onChange={(e)=>setFilters(fs => ({...fs,category:e.target.value}))}
                                                style={{
                                                    minWidth: minInputWidth,
                                                }}
                                            >
                                                <option value="">Please Select</option>
                                                <option value="category-1">Category 1</option>
                                                <option value="category-2">Category 2</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md p-0">
                                        <div className="m-2 d-md-flex align-items-center">
                                            <label
                                                htmlFor="pin"
                                                className="me-3 mb-2 mb-md-0 text-nowrap flex-fill text-md-end"
                                                style={{
                                                    width: "20ch",
                                                }}
                                            >
                                                Suburb or Postcode:
                                            </label>
                                            <input
                                                className="form-control flex-fill"
                                                type="text"
                                                name="pin"
                                                id="pin"
                                                value={filters.postcode}
                                                onChange={(e)=>setFilters(fs => ({...fs,postcode:e.target.value}))}
                                                placeholder="Enter Suburb or Postcode"
                                                style={{
                                                    minWidth: minInputWidth,
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md p-0">
                                        <div className="m-2 d-md-flex align-items-center justify-content-end">
                                            <label
                                                htmlFor="status"
                                                className="me-3 mb-2 mb-md-0 flex-fill text-md-end"
                                                style={{
                                                    width: "20ch",
                                                }}
                                            >
                                                Status:
                                            </label>
                                            <select
                                                className="form-select flex-fill"
                                                name="status"
                                                id="status"
                                                style={{
                                                    minWidth: minInputWidth,
                                                }}
                                                value={filters.status}
                                                onChange={(e)=>setFilters(fs => ({...fs,status:e.target.value}))}
                                            >
                                                <option value="">Please Select</option>
                                                <option value="expired">Expired</option>
                                                <option value="current">Current</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ms-3 my-2 d-flex justify-content-center align-items-start">
                                <button className="btn btn-primary text-light text-nowrap" disabled={isLoading}>Update Search</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            { isLoading ? (
                <div className="d-flex align-items-center justify-content-center p-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only"></span>
                    </div>
                </div>
            ) : filteredResults?.length > 0 ? (
                <div className="row row-cols-lg-3 row-cols-md-2 row-cols-1 p-2 g-0 w-100">
                    {filteredResults.map((info, i) => (
                        <div className="col d-flex" key={i}>
                            <ResultCard info={info} showDetails={showDetails} />
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-center mt-5 text-black-50">There were no records found for your search.</div>
            )}
        </div>
    );
};

export default SearchQueryToolResultPage;
